import parseTextResults from './parseTextResults'
import { imageIdToBufferIndex } from '../buffer'
import { getDWO } from '../script'
import type { BarcodeInfo } from './types'
import type { ImageID } from '../types'

export const decodeBarcodeSpeed = async (imageId: ImageID): Promise<BarcodeInfo> => {
    console.debug('decodeBarcodeSpeed', imageId)
    const t0 = performance.now()
    const dwo = await getDWO()
    const preSettings = await dwo.Addon.BarcodeReader.getRuntimeSettings('speed')
    const settings = await dwo.Addon.BarcodeReader.updateRuntimeSettings({
        ...preSettings,
        expectedBarcodesCount: 1,
    })
    console.debug('decodeBarcodeSpeed settings', settings)

    const index = await imageIdToBufferIndex(imageId)
    const textResults = await dwo.Addon.BarcodeReader.decode(index)
    const parsed = parseTextResults(textResults)
    const value = { index, imageId, ...parsed }
    console.debug('decodeBarcodeSpeed value', value)
    const t1 = performance.now()
    console.debug('decodeBarcodeSpeed', `${t1 - t0} ms`, value)
    return value
}

export const decodeBarcodeBalance = async (imageId: ImageID): Promise<BarcodeInfo> => {
    console.debug('decodeBarcodeBalance', imageId)
    const t0 = performance.now()
    const dwo = await getDWO()
    const preSettings = await dwo.Addon.BarcodeReader.getRuntimeSettings('balance')
    const settings = await dwo.Addon.BarcodeReader.updateRuntimeSettings({
        ...preSettings,
        expectedBarcodesCount: 1,
    })
    console.debug('decodeBarcodeBalance settings', settings)

    const index = await imageIdToBufferIndex(imageId)
    const textResults = await dwo.Addon.BarcodeReader.decode(index)
    const parsed = parseTextResults(textResults)
    const value = { index, imageId, ...parsed }
    console.debug('decodeBarcodeBalance value', value)
    const t1 = performance.now()
    console.debug('decodeBarcodeBalance', `${t1 - t0} ms`, value)
    return value
}

export const decodeBarcodeCoverage = async (imageId: ImageID): Promise<BarcodeInfo> => {
    console.debug('decodeBarcodeCoverage', imageId)
    const t0 = performance.now()
    const dwo = await getDWO()
    const preSettings = await dwo.Addon.BarcodeReader.getRuntimeSettings('coverage')
    const settings = await dwo.Addon.BarcodeReader.updateRuntimeSettings({
        ...preSettings,
        expectedBarcodesCount: 1,
    })
    console.debug('decodeBarcodeCoverage settings', settings)

    const index = await imageIdToBufferIndex(imageId)
    const textResults = await dwo.Addon.BarcodeReader.decode(index)
    const parsed = parseTextResults(textResults)
    const value = { index, imageId, ...parsed }
    console.debug('decodeBarcodeCoverage value', value)
    const t1 = performance.now()
    console.debug('decodeBarcodeCoverage', `${t1 - t0} ms`, value)
    return value
}

export const decodeBarcode = async (imageId: ImageID): Promise<BarcodeInfo> => {
    console.debug('decodeBarcode', imageId)
    const t0 = performance.now()
    const speedVal = await decodeBarcodeSpeed(imageId)
    if (speedVal.code) {
        const t1 = performance.now()
        console.debug('decodeBarcode speed', `${t1 - t0} ms`, speedVal)
        return { ...speedVal, settings: 'speed' }
    }

    const balanceVal = await decodeBarcodeBalance(imageId)
    if (balanceVal.code) {
        const t1 = performance.now()
        console.debug('decodeBarcode balance', `${t1 - t0} ms`, balanceVal)
        return { ...balanceVal, settings: 'balance' }
    }

    const coverageVal = await decodeBarcodeCoverage(imageId)
    const t1 = performance.now()

    if (coverageVal.code) {
        console.debug('decodeBarcode coverage', `${t1 - t0} ms`, coverageVal)
    } else {
        console.debug('decodeBarcode empty', `${t1 - t0} ms`, coverageVal)
    }

    return { ...coverageVal, settings: 'coverage' }
}
